export default "__VITE_ASSET__DSowF5r0__"